import React, { Component } from 'react';
import './WhoPanel.css';

export const id = 'WhoPanel';

class WhoPanel extends Component {

  
  render() {
    const containerClassname = this.props.isMobile ? 'MobileWhoContainer' : 'WhoContainer';
    return (
      <div className="WhoPanel" id={id}>
        <div className="WhoPanelBlurb">
          <div id="WhoContainer" className={containerClassname}>
            <h2>Who am I, really?</h2>
              <p>
                I am a Software Development Professional who currently works for Appian Corporation as a Software Engineer Lead for the Client-Side Infrastructure team.
              </p>
              <p>
                I strive to empower others. I work to accomplish this by building software to streamline build, test, and release software, by enabling a greater awareness in others, by understanding processes and simplifying them, by mastering, creating and improving software tools, and by encouraging positive collaborative work environments.
              </p>
              <p>
                During my career, I have worked on many projects on the Apple Macintosh, MS Windows, Apple iOS and Android devices, and Linux servers. These features focus on improving people’s productivity by simplifying their tools so that people are free to be more creative rather than focusing on the manual labor of configuring the computer to go through steps that can be automated.
              </p>
              <p>
                I was born in Regina, Saskatchewan, Canada, in December. I have always enjoyed cold and blustering winters although I am no longer accustomed to the cold after living in the DC Metro area for 15 years.
              </p>
              <p>
                I enjoy learning new things, scuba diving, strength training, reading, traveling, spending time with friends and family, listening to music and sharing happy moments with others.
              </p>
          </div>
        </div>
      </div>
    );
  }
}

export default WhoPanel;



// WEBPACK FOOTER //
// ./src/WhoPanel.js